import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const UbicacionPicker = ({ onChange }) => {
    const [departamentos, setDepartamentos] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [centrosPoblados, setCentrosPoblados] = useState([]);
    const [deptoId, setDeptoId] = useState('');
    const [munId, setMunId] = useState('');
    const [cpId, setCpId] = useState('');
    const [deptoSel, setDeptoSel] = useState(null);
    const [munSel, setMunSel] = useState(null);
    const [loading, setLoading] = useState({ deptos: false, munis: false, cps: false });

    const inputClass = "w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none";

    useEffect(() => {
        setLoading(l => ({ ...l, deptos: true }));
        api.get('/ubicacion/departamentos')
            .then(r => setDepartamentos(r.data))
            .finally(() => setLoading(l => ({ ...l, deptos: false })));
    }, []);

    useEffect(() => {
        if (!deptoId) { setMunicipios([]); setMunId(''); setCentrosPoblados([]); setCpId(''); setMunSel(null); return; }
        setLoading(l => ({ ...l, munis: true }));
        api.get(`/ubicacion/municipios?departamento_id=${deptoId}`)
            .then(r => setMunicipios(r.data))
            .finally(() => setLoading(l => ({ ...l, munis: false })));
    }, [deptoId]);

    useEffect(() => {
        if (!munId) { setCentrosPoblados([]); setCpId(''); return; }
        setLoading(l => ({ ...l, cps: true }));
        api.get(`/ubicacion/centros-poblados?municipio_id=${munId}`)
            .then(r => setCentrosPoblados(r.data))
            .finally(() => setLoading(l => ({ ...l, cps: false })));
    }, [munId]);

    const onDepto = (e) => {
        const id = e.target.value;
        const depto = departamentos.find(d => String(d.id) === id);
        setDeptoId(id);
        setDeptoSel(depto || null);
        setMunId(''); setMunSel(null); setCpId('');
        onChange && onChange(null, null, null);
    };

    const onMuni = (e) => {
        const id = e.target.value;
        const muni = municipios.find(m => String(m.id) === id);
        setMunId(id);
        setMunSel(muni || null);
        setCpId('');
        onChange && onChange(null, deptoSel, muni || null);
    };

    const onCp = (e) => {
        const id = e.target.value;
        setCpId(id);
        const cp = centrosPoblados.find(c => String(c.id) === id);
        onChange && onChange(cp || null, deptoSel, munSel);
    };

    return (
        <div className="space-y-3">
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Departamento *</label>
                <select value={deptoId} onChange={onDepto} className={inputClass} disabled={loading.deptos}>
                    <option value="">{loading.deptos ? 'Cargando...' : 'Seleccionar departamento...'}</option>
                    {departamentos.map(d => <option key={d.id} value={d.id}>{d.nombre}</option>)}
                </select>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Municipio *</label>
                <select value={munId} onChange={onMuni} className={inputClass} disabled={!deptoId || loading.munis}>
                    <option value="">{loading.munis ? 'Cargando...' : 'Seleccionar municipio...'}</option>
                    {municipios.map(m => <option key={m.id} value={m.id}>{m.nombre}</option>)}
                </select>
            </div>
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Centro Poblado *</label>
                <select value={cpId} onChange={onCp} className={inputClass} disabled={!munId || loading.cps}>
                    <option value="">{loading.cps ? 'Cargando...' : 'Seleccionar centro poblado...'}</option>
                    {centrosPoblados.map(c => (
                        <option key={c.id} value={c.id}>{c.nombre} ({c.tipo})</option>
                    ))}
                </select>
            </div>
        </div>
    );
};

export default UbicacionPicker;
